/**
 * Configuration for routes that require an active subscription
 * Add paths that should be protected behind subscription here
 */

export const subscriptionRouteConfig = {
  // Define routes that require subscription
  SUBSCRIPTION_REQUIRED_ROUTES: [
    '/landing/drug-search',
    // '/landing',
    '/landing/drug-search/:drugId',
    '/landing/coverage-verification',
    '/settings/organization/details',
    '/settings/organization/users',
  ],

  // Special routes for subscription management - always accessible to authenticated users
  SUBSCRIPTION_ROUTES: ['/subscription', '/subscription/payment/callback'],

  // Check if a path requires subscription
  pathRequiresSubscription(currentPath) {
    // Remove trailing slash for consistency (except for root path)
    const normalizedPath =
      currentPath === '/' ? currentPath : currentPath.replace(/\/$/, '');

    // Strip query parameters if present
    const pathWithoutQuery = normalizedPath.split('?')[0];

    // Check if the path exactly matches or is a subpath of a protected route
    return this.SUBSCRIPTION_REQUIRED_ROUTES.some((route) => {
      // Convert route pattern to regex to handle dynamic segments
      const pattern = route.replace(/:\w+/g, '[^/]+');
      const regex = new RegExp(`^${pattern}(?:/.*)?$`);
      return regex.test(pathWithoutQuery);
    });
  },

  // Check if the path is related to subscription management
  isSubscriptionRoute(path) {
    // Remove trailing slash for consistency (except for root path)
    const normalizedPath = path === '/' ? path : path.replace(/\/$/, '');

    // Strip query parameters if present
    const pathWithoutQuery = normalizedPath.split('?')[0];

    return this.SUBSCRIPTION_ROUTES.some(
      (route) =>
        pathWithoutQuery === route || pathWithoutQuery.startsWith(`${route}/`),
    );
  },
};
